import { getAllValuesAndNamesFromUrl, getValueFromUrl } from "./url";
import { getPricingObject } from "../components/product";
import { pricing } from "../utils/pricing";
import {
  returnArrayOrNull,
  returnObjectOrNull,
} from "@surf-turf/nemo/assets/utils-type-check";

const productForm = document.querySelector("product-form");

/**
 * Get correct variant from selected options.
 *
 * @param {array} variantOptions }
 *
 * @returns {object|null}
 */
const getCorrectVariantFromOptionsOrNull = (
  variantsDataObject,
  selectedOptions
) => {
  if (variantsDataObject != null) {
    return returnObjectOrNull(
      variantsDataObject.find((element) => element.options === selectedOptions)
    );
  }

  return null;
};

/**
 * Get fieldset options
 *
 * @param {HTMLElement} fieldsetElement
 */
export const getFieldsetOptions = (fieldsetElement) => {
  if (fieldsetElement) {
    const allInputElements = fieldsetElement.querySelectorAll("input");
    const allInputElementsArray = [...allInputElements];
    const allValuesFromInputElements = allInputElementsArray.map(
      (inputElement) => inputElement.value
    );

    return allValuesFromInputElements;
  }
};

/**
 * Return all options for option title.
 * So it returns a list of all the available option strings used to get the correct variant objects.
 *
 * @param {object} variantDataObject
 * @param {string} optionTitle
 *
 * @returns {string}
 */
const returnAllOptionsForOptionTitle = (variantDataObject, optionTitle) => {
  const productForm = document.querySelector("product-form");

  if (variantDataObject) {
    // Go on with the function
  } else {
    return null;
  }

  const variantOptionTitles = variantDataObject.option_titles.split(" - ");
  const variantOptionValues = variantDataObject.options.split(" - ");
  const isConnectedProduct = variantDataObject.is_connected_product === "true";
  let finalOptionTitle = optionTitle;

  if (isConnectedProduct) {
    finalOptionTitle = optionTitle
      .replace("connectedProduct", "")
      .replace(/[0-9]/g, "");
  }

  // Get index of the option to replace.
  const optionTitleIndex = variantOptionTitles.indexOf(finalOptionTitle);

  // Get the fieldset to find the other options posible with the optionTitle.
  const allFieldsetsWithOptionTitle = productForm.querySelector(
    `fieldset[name="${optionTitle}"]`
  );
  const allFieldsetInputValues = getFieldsetOptions(
    allFieldsetsWithOptionTitle
  );

  // Loop over all the available input values and set them in an array with the initial optionTitle value replaced.
  const arrayWithAllOptionValues = allFieldsetInputValues?.map((inputValue) => {
    // Replace option value with input value.
    variantOptionValues[optionTitleIndex] = inputValue;
    const newValuesString = [...variantOptionValues].join(" - ");

    return newValuesString;
  });

  return returnArrayOrNull(arrayWithAllOptionValues);
};

/**
 * Set price in input element.
 *
 * @param {HTMLElement} variantOptioninputElement
 * @param {object} variantObject
 */
const setPriceInInputElement = (inputElement, price) => {
  const inputParentElement = inputElement.closest(".input");
  const priceHolderElement = inputParentElement.querySelector(".price");

  priceHolderElement.innerHTML = pricing(price).replace(".00", " ");
};

/**
 * Set image in input element.
 *
 * @param {HTMLElement} variantOptioninputElement
 * @param {object} variantObject
 */
const setImageInInputElement = (inputElement, variantObject) => {
  const pairingUrlValue = getValueFromUrl("pairing")?.toLocaleLowerCase();
  const quantityUrlValue = getValueFromUrl("quantity")?.toLocaleLowerCase();
  const setDoubleIcon =
    pairingUrlValue === "pair" || quantityUrlValue === "pair";
  const icon = variantObject.icon;
  const doubleIcon = variantObject.double_icon || icon;
  const name = variantObject.name;
  const inputParentElement = inputElement.closest(".input");
  const imageHolderElement = inputParentElement.querySelector(".image-holder");
  const targetImage = new Image();

  targetImage.width = 58;
  targetImage.height = 38;
  targetImage.alt = name || "Size image";
  targetImage.src = setDoubleIcon ? doubleIcon : icon;

  targetImage.onload = () => {
    imageHolderElement.innerHTML = "";
    imageHolderElement.insertAdjacentElement("afterbegin", targetImage);
  };
};

/**
 * Get all variant options for size.
 *
 * @param {object} allVariantDataObjects
 */
export const handleSetPriceInFieldsetElement = (
  optionTitle,
  connectedProductId
) => {
  const productForm = document.querySelector("product-form");
  const correctVariantObjects = getAllVariantDataObjectsFromUrl();
  let productVariantData = null;
  let allVariantDataObjects = null;

  if (!correctVariantObjects) return null; // If there is no correct variant object abort mission.

  // Get the size fieldset element.
  const fieldsetWithOptionTitle =
    productForm.querySelector(`fieldset[name="${optionTitle}"]`) || null;

  // Get all the size fieldset elmeents.
  const allInputElements = fieldsetWithOptionTitle
    ? fieldsetWithOptionTitle.querySelectorAll("input")
    : null;

  if (!allInputElements) return null; // There are no input elements in the fieldset so there can't a price to set in the input.

  const allInputElementsArray = [...allInputElements];

  if (connectedProductId) {
    // Get the list with all variant options for the connected product.
    const connectedProductVariantDataJson = document.querySelector(
      `.connected-product-variant-data[data-connected-product-id="${connectedProductId}"]`
    );
    const connectedProductVariantData = connectedProductVariantDataJson
      ? JSON.parse(connectedProductVariantDataJson.innerHTML).variants
      : null;

    allVariantDataObjects = connectedProductVariantData;
    productVariantData =
      correctVariantObjects.connectedProducts.find(
        (connectedProductVariantObject) =>
          connectedProductVariantObject.connectedProductId ===
          connectedProductId
      ) || connectedProductVariantData[1];
  } else {
    const mainProductVariantDataJson = document.querySelector("#variants-data");
    const mainProductVariantData = mainProductVariantDataJson
      ? JSON.parse(mainProductVariantDataJson.innerHTML).variants
      : null;

    allVariantDataObjects = mainProductVariantData;
    productVariantData = correctVariantObjects.mainProduct;
  }

  // Get all size options for the main product.
  const allOptions = returnAllOptionsForOptionTitle(
    productVariantData,
    optionTitle
  );

  // Get value of pairing from url.
  const productPairing = getValueFromUrl("pairing");
  const productQuantity = getValueFromUrl("quantity");

  // Loop over the input elements.
  if (allOptions) {
    allInputElementsArray.map((inputElement, index) => {
      if (allOptions[index].includes("none")) {
        // Do nothing.
      } else {
        const correctVariantObject = getCorrectVariantFromOptionsOrNull(
          allVariantDataObjects,
          allOptions[index]
        );

        if (correctVariantObject) {
          const price = correctVariantObject.price;

          if (
            (productPairing && productPairing === "pair") ||
            (productQuantity && productQuantity === "pair")
          ) {
            // Double the price and set it in the input element.
            setPriceInInputElement(inputElement, Number(price) * 2);
          } else {
            // Set the price in the input element.
            setPriceInInputElement(inputElement, price);
          }
        }
      }
    });
  } else {
    // Do nothing
  }
};

/**
 * Get all variant options for size.
 *
 * @param {object} allVariantDataObjects
 */
export const handleSetImageInSizeFieldsetElements = (
  optionTitle,
  connectedProductId
) => {
  const productForm = document.querySelector("product-form");
  const correctVariantObjects = getAllVariantDataObjectsFromUrl();
  const productColor = getValueFromUrl("color");
  let productVariantData = null;
  let allVariantDataObjects = null;

  if (!correctVariantObjects) return null; // If there is no correct variant object abort mission.

  // Get the size fieldset element.
  const fieldsetWithOptionTitle =
    productForm.querySelector(`fieldset[name="${optionTitle}"]`) || null;

  // Get all the size fieldset elmeents.
  const allInputElements = fieldsetWithOptionTitle
    ? fieldsetWithOptionTitle.querySelectorAll("input")
    : null;

  if (!allInputElements) return null; // There are no input elements in the fieldset so there can't a price to set in the input.

  const allInputElementsArray = [...allInputElements];

  if (connectedProductId) {
    // Get the list with all variant options for the connected product.
    const connectedProductVariantDataJson = document.querySelector(
      `.connected-product-variant-data[data-connected-product-id="${connectedProductId}"]`
    );
    const connectedProductVariantData = connectedProductVariantDataJson
      ? JSON.parse(connectedProductVariantDataJson.innerHTML).variants
      : null;

    allVariantDataObjects = connectedProductVariantData;

    // Get product variant data by connected product id.
    const productVariantDataById =
      correctVariantObjects.connectedProducts.find(
        (connectedProductVariantObject) =>
          connectedProductVariantObject.connectedProductId ===
          connectedProductId
      ) || null;

    // If there is no connected product id, look for a match with the product color.
    const productVariantDataByColor = allVariantDataObjects.find(
      (variantObject) =>
        variantObject.title?.toLowerCase().includes(productColor)
    );

    // Fallback to the first variant in the product variant data.
    const productVariantDataByIndex = connectedProductVariantData[1];

    if (productVariantDataById) {
      productVariantData = productVariantDataById;
    } else if (productVariantDataByColor) {
      productVariantData = productVariantDataByColor;
    } else {
      productVariantData = productVariantDataByIndex;
    }
  } else {
    const mainProductVariantDataJson = document.querySelector("#variants-data");
    const mainProductVariantData = mainProductVariantDataJson
      ? JSON.parse(mainProductVariantDataJson.innerHTML).variants
      : null;

    allVariantDataObjects = mainProductVariantData;
    productVariantData = correctVariantObjects.mainProduct;
  }

  // Get all size options for the main product.
  const allSizeOptions = returnAllOptionsForOptionTitle(
    productVariantData,
    optionTitle
  );

  // Loop over the input elements.
  if (allSizeOptions) {
    allInputElementsArray.map((inputElement, index) => {
      const correctVariantObject = getCorrectVariantFromOptionsOrNull(
        allVariantDataObjects,
        allSizeOptions[index]
      );

      if (correctVariantObject) {
        // Set the price in the input element.
        setImageInInputElement(inputElement, correctVariantObject);
      }
    });
  } else {
    // Do nothing
  }
};

/**
 * Set price in Pairing inputs
 */
export const handleSetPriceInPairingFielsetElements = (
  optionTitle,
  connectedProductId
) => {
  const productForm = document.querySelector("product-form");
  const correctVariantObjects = getAllVariantDataObjectsFromUrl();
  let productVariantData = null;
  let allVariantDataObjects = null;

  if (!correctVariantObjects) return null; // If there is no correct variant object abort mission.

  if (connectedProductId) {
    // Get the list with all variant options for the connected product.
    const connectedProductVariantDataJson = document.querySelector(
      `.connected-product-variant-data[data-connected-product-id="${connectedProductId}"]`
    );
    const connectedProductVariantData = connectedProductVariantDataJson
      ? JSON.parse(connectedProductVariantDataJson.innerHTML).variants
      : null;

    allVariantDataObjects = connectedProductVariantData;
    productVariantData = correctVariantObjects.connectedProducts.find(
      (connectedProductVariantObject) =>
        connectedProductVariantObject.connectedProductId === connectedProductId
    );
  } else {
    const mainProductVariantDataJson = document.querySelector("#variants-data");
    const mainProductVariantData = mainProductVariantDataJson
      ? JSON.parse(mainProductVariantDataJson.innerHTML).variants
      : null;

    allVariantDataObjects = mainProductVariantData;

    productVariantData = correctVariantObjects.mainProduct;
  }

  // Get all size options for the main product.
  const allOptions = returnAllOptionsForOptionTitle(
    productVariantData,
    optionTitle
  );

  // Get the size fieldset element.
  const fieldsetWithOptionTitle = productForm.querySelector(
    `fieldset[name="${optionTitle}"]`
  );

  // Check if pairing fieldset exists.
  if (!fieldsetWithOptionTitle) return null;

  // Get all the size fieldset elmeents.
  const allInputElements = fieldsetWithOptionTitle.querySelectorAll("input");
  const allInputElementsArray = [...allInputElements];

  // Loop over the input elements.
  if (allOptions) {
    allInputElementsArray.map((inputElement, index) => {
      const correctVariantObject = getCorrectVariantFromOptionsOrNull(
        allVariantDataObjects,
        allOptions[index]
      );

      if (correctVariantObject) {
        // Set the price in the input element.
        const price = correctVariantObject.price;
        let connectedProductsPricing = 0;

        // Check if there are any connected products.
        correctVariantObjects.connectedProducts?.map(
          (connectedProductVariantObject) => {
            connectedProductsPricing += connectedProductVariantObject.price
              ? connectedProductVariantObject.price
              : 0;
          }
        );

        // Mutlply the connected product by 2 if the pairing is set to 2
        if (allOptions[index].includes("pair")) {
          connectedProductsPricing = connectedProductsPricing * 2;
        }

        const inputParentElement = inputElement.closest(".input");
        const priceHolderElement = inputParentElement.querySelector(".price");

        priceHolderElement.innerHTML = pricing(
          Number(price) + Number(connectedProductsPricing)
        );
      }
    });
  } else {
    // Do nothing
  }
};

/**
 * Get the variant data objects of the main product and the connected products from the url.
 *
 * @returns {object}
 */
export const getAllVariantDataObjectsFromUrl = () => {
  // Get all values from url parameters.
  const allValuesAndNamesFromUrl = getAllValuesAndNamesFromUrl();

  if (allValuesAndNamesFromUrl) {
    // Carry on.
  } else {
    return null;
  }

  // Loop over connected products to get their variantData.
  const allConnectedProductVariantDataJson = document.querySelectorAll(
    ".connected-product-variant-data"
  );
  const allConnectedProductVariantDataJsonArray = [
    ...allConnectedProductVariantDataJson,
  ];
  const allConnectedProductVariantData =
    allConnectedProductVariantDataJsonArray.map((variantDataJson) =>
      variantDataJson ? JSON.parse(variantDataJson.innerHTML).variants : null
    );

  const mainProductVariantDataJson = document.querySelector("#variants-data");
  const mainProductVariantData = mainProductVariantDataJson
    ? JSON.parse(mainProductVariantDataJson.innerHTML).variants
    : null;

  // Look for each name for the matching fieldset element.
  const variantOptionsStringMainProduct = allValuesAndNamesFromUrl
    .map((valueAndName) => {
      // Filter out the connected product values and the quantity value from the url.
      if (
        !valueAndName.name.includes("connectedProduct") &&
        !valueAndName.name.includes("quantity") &&
        !valueAndName.name.includes("initial")
      ) {
        return valueAndName.value;
      } else {
        return false;
      }
    })
    .filter((variantOption) => variantOption)
    .sort()
    .join(" - ");

  // Loop over connected product variant data's
  const allCorrectConnectedProductVariants = allConnectedProductVariantData.map(
    (variantData, index) => {
      const variantOptionsStringConnectedProduct = allValuesAndNamesFromUrl
        .map((valueAndName) => {
          if (
            !valueAndName.name.includes("connectedProduct") &&
            !valueAndName.name.includes("quantity") &&
            !valueAndName.name.includes("pairing")
          ) {
            return valueAndName.value;
          } else {
            // Only allow the connected product with the same index.
            if (valueAndName.name.includes(index + 1)) {
              return valueAndName.value;
            } else {
              return null;
            }
          }
        })
        .filter((variantOption) => variantOption)
        .sort()
        .join(" - ");

      const variantObject = getCorrectVariantFromOptionsOrNull(
        variantData,
        variantOptionsStringConnectedProduct
      );

      if (variantObject) {
        variantObject.connectedProductId = `connectedProduct${index + 1}`;
      }

      return {
        ...variantObject,
      };
    }
  );
  // Get the correct main product variant object.
  let correctMainProductVariant = getCorrectVariantFromOptionsOrNull(
    mainProductVariantData,
    variantOptionsStringMainProduct
  );

  if (!correctMainProductVariant) {
    // If there is no correct main product variant, then we can't find any variants that are not yet connected.
    const retryAllVAluesAndNamesFromUrl = getAllValuesAndNamesFromUrl();

    const arrayOfRetryAllVAluesAndNamesFromUrl = retryAllVAluesAndNamesFromUrl
      .map((valueAndName) => {
        // Filter out the connected product values and the quantity value from the url.
        if (
          !valueAndName.name.includes("connectedProduct") &&
          !valueAndName.name.includes("quantity")
        ) {
          return valueAndName.value;
        } else {
          return false;
        }
      })
      .filter((variantOption) => variantOption)
      // .sort()
      .join(" - ");

    // const alternativeOptionString = variantOptionsStringMainProduct
    correctMainProductVariant = getCorrectVariantFromOptionsOrNull(
      mainProductVariantData,
      arrayOfRetryAllVAluesAndNamesFromUrl
    );
  }

  if (!correctMainProductVariant) {
    // If there is no correct main product variant, then we can't find any variants that are not yet connected.
    const alternativeOptionString = variantOptionsStringMainProduct
      .replace("left", "single")
      .replace("right", "single");
    correctMainProductVariant = getCorrectVariantFromOptionsOrNull(
      mainProductVariantData,
      alternativeOptionString
    );
  }

  return {
    connectedProducts: allCorrectConnectedProductVariants,
    mainProduct: correctMainProductVariant,
  };
};

/**
 * Handle set price in quantity property.
 */
export const handleSetPriceInQuantity = () => {
  const fieldsetName = "quantity";
  const fieldsetElement = productForm.querySelector(
    `fieldset[name="${fieldsetName}"]`
  );

  if (!fieldsetElement) return null;

  // Get all the input elements.
  const allInputElements = fieldsetElement.querySelectorAll("input");
  const arrayOfAllInputElements = [...allInputElements];
  const activeQuantityElement = fieldsetElement.querySelector("input:checked");
  const activeQuantityValue = activeQuantityElement.value;

  // Get the selected main product and connected product.
  const selectedProductPriceObject = getPricingObject();
  const totalPrice = selectedProductPriceObject?.total.price;

  // If pair is set, don't multiply the price by 2.
  if (activeQuantityValue === "pair") {
    // Loop over all inputs and get the quantity from them.
    arrayOfAllInputElements.map((inputElement) => {
      const priceHolderElement = inputElement
        .closest(".input")
        .querySelector(".price");
      const quantity = inputElement.dataset.value;
      let newPrice = null;

      if (quantity == 2) {
        // The current price is the price multiplied by 2.
        newPrice = totalPrice;
      } else {
        // Divide the price by 2.
        newPrice = totalPrice / 2;
      }
      priceHolderElement.innerHTML = pricing(newPrice);
    });
  } else {
    // Loop over all inputs and get the quantity from them.
    arrayOfAllInputElements.map((inputElement) => {
      const priceHolderElement = inputElement
        .closest(".input")
        .querySelector(".price");
      const quantity = inputElement.dataset.value;
      const newPrice = totalPrice * quantity;
      priceHolderElement.innerHTML = pricing(newPrice);
    });
  }
};
